module.exports = __webpack_public_path__ + "img/sftpIconLarge.2e99bf61.png";